import { FC } from 'react';
import { Modal } from 'react-bootstrap';

import { useTranslate } from 'hooks/useTranslate';

import { useAiQuotaExceededModal } from '../context/AiQuotaExceededModalContext';

const AiQuotaExceededModalHeader: FC = () => {
  const { t } = useTranslate();
  const { actions } = useAiQuotaExceededModal();

  return (
    <Modal.Header>
      <div className="row">
        <h5 className="title col-12">{t('AI_QuotaExceededTitle')}</h5>
      </div>
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
      <a className="close cursor-pointer" onClick={actions.handleCloseModal}>
        <em className="icon ni ni-cross" />
      </a>
    </Modal.Header>
  );
};

export default AiQuotaExceededModalHeader;
